import { mergeClassName as e } from "../../utils/data.js";
import t from "./Column.module.js";
import { jsx as n } from "react/jsx-runtime";
//#region lib/components/Layout/Column.tsx
function r({ children: r, spacing: i = 3, className: a, style: o, ...s }) {
	return /* @__PURE__ */ n("div", {
		...s,
		style: {
			gap: `var(--ag-spacing-${String(i)})`,
			...o
		},
		className: e(t.column, a),
		children: r
	});
}
//#endregion
export { r as Column };
